import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js';
import pattern from 'patternomaly';
import { ReportService } from '../../services/report.service';
import moment from 'moment';
import { PlantService } from '../../services/plant.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  // @ViewChild('mapContainer') gmap: ElementRef;
  @ViewChild('donutChart') donutChart: ElementRef;
  @ViewChild('barChart') barChart: ElementRef;
  @ViewChild('gmap', {static: false}) gmap: ElementRef;
  coordinates;
  options;
  activeDots = 'assets/icons/green-dot.png';
  inactiveDots = 'assets/icons/gray-dot.png';
  activeMarkerOptions: google.maps.MarkerOptions = { draggable: false, icon: this.activeDots };
  inactiveMarkerOptions: google.maps.MarkerOptions = { draggable: false, icon: this.inactiveDots };
  activeMarkerPositions = [];
  inactiveMarkerPositions = [];
  map: google.maps.Map;
  heatmap: google.maps.visualization.HeatmapLayer = null;
  centerLatitude = 5.019763;
  centerLongitude = 105.149240;
  currentDatetime;
  chartData;
  chartLabel = 'Hola'
  chartOptions;
  chartType = 'doughnut';
  yieldList;
  activePlantCount;
  inactivePlantCount;
  totalSunhour;
  totalYield;
  currentYear;
  currentMonth;

  constructor(
    private reportService: ReportService,
    private plantService: PlantService,
  ) { }

  ngOnInit() {
    const now = moment();
    this.currentMonth = now.format('MMM');
    this.currentYear = now.format('yyyy');
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    setInterval(() => { this.ngAfterViewInit() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  ngAfterViewInit() {
    this.options = {
      center: { lat: +this.centerLatitude, lng: +this.centerLongitude },
      zoom: 7.5,
      mapId: '2bb08ed6f45c665a',
      disableDefaultUI: true,
      mapTypeControl: false,
      // gestureHandling: "none",
      // zoomControl: false,
    };
    this.map = new google.maps.Map(this.gmap.nativeElement, this.options);
    this.initDoughnutChart();
    this.reportService.getDailyYieldSummary().subscribe(resp => {
      this.yieldList = resp.data.result;
      console.log(`this.yieldList >> ${JSON.stringify(this.yieldList)}`);
      this.yieldList.map(y => {
        y.date = moment(y.date, 'YYYY-MM-DD').format('MMM D');
      })
      this.initBarChart();
    });

    this.reportService.getTotalYieldSummary().subscribe(resp => {
      console.log(`total yield resp >> ${JSON.stringify(resp)}`);
      const data = resp.data.result;
      this.activePlantCount = data.activePlantCount;
      this.inactivePlantCount = data.inactivePlantCount;
      this.totalYield = data.totalYield;
      this.totalSunhour = data.totalSunhour;
    });

    this.plantService.getPlantLocations().subscribe(resp => {
      const plantList = resp.data;
      console.log(`plantList >> ${JSON.stringify(plantList)}`);
      const activePlant = plantList.filter(p => p.deleted === null);
      const inactivePlant = plantList.filter(p => p.deleted === 1);
      activePlant.map(a => {
        if (!isNaN(a.latitude) && !isNaN(a.longitude)) {
          this.activeMarkerPositions.push(new google.maps.LatLng({ lat: +a.latitude, lng: +a.longitude }));
        } else {
          console.log(`a.latitude >> ${a.latitude} ... a.longitude >> ${a.longitude}`);
        }
      });
      inactivePlant.map(a => {
        this.activeMarkerPositions.push(new google.maps.LatLng({ lat: +a.latitude, lng: +a.longitude }));
      });

      const coords: google.maps.LatLng[] =  this.activeMarkerPositions; // can also be a google.maps.MVCArray with LatLng[] inside
      this.heatmap = new google.maps.visualization.HeatmapLayer({
          map: this.map,
          data: coords
      });

      this.heatmap.set('radius', 14);
      this.heatmap.set('opacity', 1);
    });
  }

  initDoughnutChart() {
    const ctx = (<HTMLCanvasElement>this.donutChart.nativeElement).getContext('2d');
    return new Chart(ctx, {
      type: 'doughnut',
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        cutoutPercentage: 60
      },
      data: {
        labels: ['Active', 'Inactive'],
        datasets: [{
          label: '# of Plants',
          data: [100, 20],
          backgroundColor: [
            '#00FFE0',
            'transparent',
          ],
          borderColor: [
            '#8798AD',
            '#8798AD',
          ],
          borderWidth: 2
        }]
      }
    });

    // type: 'doughnut',
    // data: {
    //     labels: ["Red", "GG"],
    //     datasets: [{
    //         label: '# of Votes',
    //         data: [12, 2],
    //         backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)',
    //             'rgba(255, 99, 111, 0.2)',
    //         ],
    //         borderColor: [
    //             'rgba(255,99,132,1)',
    //              'rgba(255,99,132,1)',
    //         ],
    //         borderWidth: 1
    //     }]
    // },
    // options: {
    //     rotation: 1 * Math.PI,
    //     circumference: 1 * Math.PI
    // }
  }

  initBarChart() {
    const ctx = (<HTMLCanvasElement>this.barChart.nativeElement).getContext('2d');
    const colorGradient = ctx.createLinearGradient(0, 0, 0, 200);
    colorGradient.addColorStop(0, '#181818');
    colorGradient.addColorStop(1, '#404040');
    const yieldData = this.yieldList.map(y => y.yield)
    const max = Math.max(...yieldData);
    return new Chart(ctx, {
      type: 'bar',
      options: {
        responsive: false,
        maintainAspectRatio: false,
        title: {
          text: 'Past 10 Days Daily Power Output (kWh)',
          fontColor: '#FFF',
          display: true,
          fontSize: 30,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              display: true,
              autoSkip: true,
              maxTicksLimit: 10,
              fontColor: '#FFF',
              padding: 8,
              fontSize: 20,
            },
            gridLines: {
              drawOnChartArea: false,
              color: '#FFF',
              drawBorder: true,
              drawTicks: false,
              lineWidth: 2,
              z: 10,
              zeroLineColor: 'transparent',
              borderDashOffset: 10,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              precision: 0,
              min: 0,
              stepSize: 1,
              fontColor: '#FFF',
            },
            gridLines: {
              display: false,
            },

          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'index',
          intersect: false,
        }
      },
      data: {
        labels: this.yieldList.map(y => y.date),
        datasets: [
          {
            label: 'a',
            data: yieldData,
            backgroundColor: pattern.draw('line', '#8829a0', '#000', 15),
          },
          {
            label: 'b',
            data: this.yieldList.map(y => max - y.yield),
            backgroundColor: colorGradient,
          }
        ],
      }
    });
  }
}
